const Columns = [
  {
    id: 'switch',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    employee: true,
    isSortable: true,
    gray:true,
  },
  // {
  //   id: 'acuityId',
  //   numeric: false,
  //   disablePadding: true,
  //   label: 'Acuity ID',
  //   isSortable: true,
  // },
  {
    id: 'userName',
    numeric: false,
    disablePadding: true,
    label: 'Employee Name',
    isSortable: true,
    gray:true,
  },
  {
    id: 'phoneNumber',
    numeric: false,
    disablePadding: true,
    label: 'Contact',
    isSortable: true,
    gray:true,
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    label: 'Email',
    isSortable: true,
    gray:true,
  },
  {
    id: 'employeerole',
    numeric: false,
    disablePadding: false,
    label: 'Employee Role',
    isSortable: true,
    gray:true,
  },
  {
    id: 'action',
    numeric: false,
    disablePadding: true,
    label: 'Action',
    rowclassName: '',
    gray:true,
    className: 'pr-30',
  },
];

const ColumnsRes = [
  {
    id: 'employeerole',
    numeric: false,
    disablePadding: false,
    label: 'Employee Role',
    isSortable: true,
  },
  {
    id: 'phoneNumber',
    numeric: false,
    disablePadding: true,
    label: 'Contact',
    isSortable: true,
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    label: 'Email',
    isSortable: true,
  },
  {
    id: 'company',
    numeric: false,
    disablePadding: false,
    label: 'Company',
    isSortable: true,
    isCollapsible: true,
  },
  // {
  //   id: 'acuityId',
  //   numeric: false,
  //   disablePadding: true,
  //   label: 'Acuity ID',
  //   isSortable: true,
  //   isCollapsible: true,
  // },
  {
    id: 'action',
    numeric: false,
    disablePadding: true,
    label: 'Action',
    isCollapsible: true,
  },
  {
    id: 'switch',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    isSortable: true,
    isCollapsible: true,
  },
];

export { Columns, ColumnsRes };
